/**
 * Compute SHA256 hash of data and return as hex string.
 * Uses SubtleCrypto for browser compatibility.
 *
 * @param data The data to hash
 * @returns SHA256 hash as lowercase hex string
 */
export async function computeSha256Hex(data: Uint8Array): Promise<string> {
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
